module.exports = __webpack_public_path__ + "img/videoxin-red.1bdb9a02.png";